import React from 'react';

const CriticalHomepageCSS = () => {
  const criticalCSS = `
    /* Critical CSS for above-the-fold content - Homepage only */
    :root {
      --background: 0 0% 100%;
      --foreground: 240 10% 3.9%;
      --primary: 142 76% 36%;
      --primary-foreground: 355.7 100% 97.3%;
      --border: 240 5.9% 90%;
      --brand-green: 142 76% 36%;
    }

    /* Essential layout for hero section */
    .flex { display: flex; }
    .items-center { align-items: center; }
    .justify-center { justify-content: center; }
    .w-full { width: 100%; }
    .h-auto { height: auto; }
    .max-w-7xl { max-width: 80rem; }
    .mx-auto { margin-left: auto; margin-right: auto; }
    .px-4 { padding-left: 1rem; padding-right: 1rem; }
    .py-16 { padding-top: 4rem; padding-bottom: 4rem; }
    .py-12 { padding-top: 3rem; padding-bottom: 3rem; }
    .mb-8 { margin-bottom: 2rem; }
    .mb-4 { margin-bottom: 1rem; }
    .rounded-lg { border-radius: 0.5rem; }
    .rounded { border-radius: 0.25rem; }
    .bg-white { background-color: rgb(255 255 255); }
    .text-4xl { font-size: 2.25rem; line-height: 2.5rem; }
    .text-xl { font-size: 1.25rem; line-height: 1.75rem; }
    .text-lg { font-size: 1.125rem; line-height: 1.75rem; }
    .font-bold { font-weight: 700; }
    .font-semibold { font-weight: 600; }
    .text-center { text-align: center; }
    .object-cover { object-fit: cover; }
    .shadow-xl { box-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1); }
    .border { border-width: 1px; }
    .text-\\[\\#34BF49\\] { color: #34BF49; }
    .border-brand-green\\/10 { border-color: hsl(var(--brand-green) / 0.1); }
    .grid { display: grid; }
    .inline-flex { display: inline-flex; }
    .h-12 { height: 3rem; }
    .px-6 { padding-left: 1.5rem; padding-right: 1.5rem; }

    /* Responsive design */
    @media (min-width: 768px) {
      .md\\:flex { display: flex; }
      .md\\:w-1\\/3 { width: 33.333333%; }
      .md\\:w-2\\/3 { width: 66.666667%; }
      .sm\\:px-6 { padding-left: 1.5rem; padding-right: 1.5rem; }
    }

    @media (min-width: 1024px) {
      .lg\\:px-8 { padding-left: 2rem; padding-right: 2rem; }
    }

    /* Defer non-critical sections */
    section:not(:first-of-type) {
      opacity: 0;
      animation: fadeInLater 0.3s ease-in-out 0.5s forwards;
    }

    @keyframes fadeInLater {
      to { opacity: 1; }
    }
  `;

  return (
    <style dangerouslySetInnerHTML={{ __html: criticalCSS }} />
  );
};

export default CriticalHomepageCSS;